const CreateWireBeneficiaryTemplateStyle = {
	
};

export default CreateWireBeneficiaryTemplateStyle;
